<template>
  <div class="row">
    <div class="col-md-5">
      <b-form-group label="Concepto Presupuestario">
        <v-select
          class="w-100"
          :class="{
              'v-select-danger': errors.has('custom-document-part-2.budgetConcept')
            }"
          data-cy="budget-concept"
          data-vv-as="concepto presupuestario"
          name="budgetConcept"
          :options="optionsBudgetConcept"
          v-model="budgetConceptForm.budgetConcept"
          v-validate="'required'"
        >
          <template #spinner>
            <b-spinner
              small
              v-if="isLoadOptions"
              :style="{ opacity: isLoadOptions ? 1 : 0}"
              variant="primary"
            />
          </template>
          <template slot="no-options">
            no hay concepto presupuestario para el criterio de búsqueda
          </template>
        </v-select>
        <div
          v-if="errors.has('custom-document-part-2.budgetConcept')"
          class="con-text-validation span-text-validation-danger v-enter-to"
        >
          <span class="span-text-validation">
            {{ errors.first('custom-document-part-2.budgetConcept') }}
          </span>
        </div>
      </b-form-group>
    </div>
    <div class="col-md-4 ">
      <InputCurrency
        v-model="budgetConceptForm.amount"
        id="amount"
        name="amount"
        data-cy="amount"
        v-validate="'required|min:1'"
        :state="errors.has('custom-document-part-2.amount') ? false : null"
        :danger="errors.has('custom-document-part-2.amount')"
        :danger-text="errors.first('custom-document-part-2.amount')"
        data-vv-as="monto"
      />
    </div>
    <div class="col-md-3 d-flex align-items-center justify-content-end">
      <b-button
        data-cy="add-budget-concept"
        variant="primary"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        @click="addBudgetConcept()"
      >
        Agregar Concepto
      </b-button>
    </div>
    <div class="col-md-12">
      <div
        v-if="!!error.message"
        class="con-text-validation span-text-validation-danger
                vs-input--text-validation-span v-enter-to text-left"
      >
        <span class="span-text-validation">
          {{ error.message }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive';

import { ioListOptions } from '@/febos/servicios/api/herramientas.api';
import InputCurrency from '@/components/InputCurrency';

export default {
  components: { InputCurrency },
  directives: {
    Ripple
  },
  data() {
    return {
      budgetConceptForm: {
        budgetConcept: '',
        amount: 0
      },
      optionsBudgetConcept: [],
      isLoadOptions: false,
      error: {
        message: ''
      }
    };
  },
  methods: {
    async loadOptions() {
      try {
        this.isLoadOptions = true;
        const response = await ioListOptions({
          grupoOpcion: 'io.concepto.prespuestario.gore',
          filtros: 'deshabilitado:0'
        });
        const { opciones } = response.data;
        this.optionsBudgetConcept = opciones
          .sort(({ descripcion: a }, { descripcion: b }) => a.localeCompare(b))
          .map((option) => ({
            label: `(${option.valor}) ${option.descripcion}`,
            value: option.valor
          }));
      } finally {
        this.isLoadOptions = false;
      }
    },
    maxLengthAmount(value) {
      return String(value).substring(0, 15);
    },
    async addBudgetConcept() {
      const isValid = await this.validateForm('custom-document-part-2');
      if (!isValid) {
        return;
      }
      if (!this.budgetConceptForm.amount || this.budgetConceptForm.amount === 0) {
        this.error.message = 'Debes agregar un valor válido para el monto';
        return;
      }

      const row = {
        ...this.budgetConceptForm
      };

      this.$emit('add-budget-concept', row);

      this.budgetConceptForm.budgetConcept = '';
      this.budgetConceptForm.amount = 0;
      this.error.message = '';

      await this.$validator.reset();
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    }
  },
  created() {
    this.loadOptions();
  }
};
</script>
